import React from 'react';
import { connect } from 'react-redux';

import ManageYachtBookingPresenter from './ManageYachtBookingPresenter';

// Redux
import { initBooking, fetchCreateBooking } from '../../bookings/redux/_actions';

class CreateYachtBookingContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            isReadOnly: false,
            pageTitle: 'CREATE BOOKING'
        };
    }

    componentDidMount() {
        this.props.initBooking();
        this.setState({ loading: false });
    }

    onSubmit(form_props) {
        const yachtID = this.props.match.params.id;
        const params = Object.assign({},{
            ...form_props,
            yacht_id: yachtID
        });

        this.setState({ loading: true });
        this.props.fetchCreateBooking(params)
            .then(data => {
                this.setState({ loading: false });

                if (data) {
                    this.props.history.push(`/yachts/view/charter/${yachtID}/bookings/`);
                }
            });
    }

    render() {
        return (
            <ManageYachtBookingPresenter
                loading={this.state.loading}
                user_role={this.props.user_role}
                history={this.props.history}
                match={this.props.match}
                isReadOnly={this.state.isReadOnly}
                pageTitle={this.state.pageTitle}
                onSubmit={this.onSubmit.bind(this)}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        user_role: state.auth.user_role
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initBooking: () => dispatch(initBooking()),
        fetchCreateBooking: params => dispatch(fetchCreateBooking(params))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateYachtBookingContainer);
